"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var inject_exports = {};
__export(inject_exports, {
  injectSurveyorTeamFields: () => injectSurveyorTeamFields
});
module.exports = __toCommonJS(inject_exports);
var import_topo_form = require("@cartographerio/topo-form");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_helpers = require("./helpers.js");
var import_rule = require("./rule/index.js");
var import_rule2 = require("./rule/rule.js");
var import_teamMateRule = require("./rule/teamMateRule.js");
var import_teamAssociationRule = require("./rule/teamAssociationRule.js");
function documentAsSurvey(env) {
  const doc = env.doc();
  return (0, import_types.isSurvey)(doc) ? doc : (0, import_util.raise)("Surveyor validation rules not given a survey");
}
function injectSurveyorTeamFields(formSchema, identity, graph, defaultSurvey, editable) {
  const project = graph.findProjectById(defaultSurvey.projectId);
  const surveyorRule = editable ? (0, import_rule2.ruleSequence)(import_teamMateRule.teamMateRule, import_rule.surveyorTeamRule)({ identity, graph, project }) : null;
  const teamRule = editable ? (0, import_rule2.ruleSequence)(import_rule.ownTeamRule, import_teamAssociationRule.teamAssociationRule)({ identity, graph, project }) : null;
  const isMultiTeam = (0, import_helpers.checkMultiTeam)(graph, defaultSurvey.projectId);
  const [firstPage, ...tailPages] = formSchema.pages;
  const surveyorField = (0, import_topo_form.primarySurveyorField)({
    label: formSchema.surveyorLabel ?? "Surveyor",
    help: formSchema.surveyorHelp,
    rule: (env) => surveyorRule?.(documentAsSurvey(env)) ?? []
  });
  const identityBlock = isMultiTeam ? (0, import_topo_form.columns2)(
    surveyorField,
    (0, import_topo_form.primaryTeamField)({
      label: formSchema.teamLabel ?? "Team",
      help: formSchema.teamHelp,
      rule: (env) => teamRule?.(documentAsSurvey(env)) ?? []
    })
  ) : (0, import_topo_form.columns2)(surveyorField);
  return {
    ...formSchema,
    pages: [{ ...firstPage, blocks: [identityBlock, ...firstPage.blocks] }, ...tailPages]
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  injectSurveyorTeamFields
});
//# sourceMappingURL=inject.js.map
